export default "/images/vendor/flag-icon-css/flags/1x1/mk.svg?c370fe88a49ab3c18701c98f02ebbcf4";